document.addEventListener("DOMContentLoaded", function () {
  iniciarApp();
});
function iniciarApp() {
  navegacionFija();
  crearGaleria();
  scrollNav();
  //animaciones();
  gsapAnimation();
  animacionesDos();
}
function animacionesDos() {
  
  var options = {
    imgSrc : "build/img/perf.jpg",
    containerName : "placeholder",
    rows:5,
    columns:5,
    margin:2.5,
    animTime: 0.3
  }
  
  function ImageGrid(defaults)
  {
    var r = defaults.rows;
    var c = defaults.columns;
    var margin = defaults.margin;
      
    var placeholder = document.getElementsByClassName(defaults.containerName)[0];
    var container = document.createElement('div');
    container.className = "gridContainer";
    placeholder.appendChild(container); 
      
    var gridTile;  
  
    var w = (container.offsetWidth / c) -margin;
    var h = (container.offsetHeight / r) -margin;
    var arr = [];
      
    for (var i=0, l=r*c; i < l; i++)
    {    
      gridTile = document.createElement('div');
      gridTile.className = "gridTile";
      gridTile.style.backgroundImage = "url("+defaults.imgSrc+")";
      
         
      arr = [(w+margin)*(i%c), (h+margin)*Math.floor(i/c), ((w+margin)*(i%c)+w-margin), (h+margin)*Math.floor(i/c), ((w+margin)*(i%c)+w-margin), ((h+margin)*Math.floor(i/c) + h-margin), (w+margin)*(i%c), ((h+margin)*Math.floor(i/c) + h-margin)];
          
     // console.log(i + " ====>>> " + arr + " ||||| " + i%c  + " |||||| " + i/c);  
      
          
      TweenMax.set(gridTile, {webkitClipPath:'polygon('+arr[0]+'px '+ arr[1]+'px,'+arr[2]+'px '+arr[3]+'px, '+arr[4]+'px '+ arr[5] +'px, '+arr[6]+'px '+ arr[7] +'px)', clipPath:'polygon('+arr[0]+'px '+ arr[1]+'px,'+arr[2]+'px '+arr[3]+'px, '+arr[4]+'px '+ arr[5] +'px, '+arr[6]+'px '+ arr[7] +'px)'});
         
      container.appendChild(gridTile);    
      
      fixTilePosition(gridTile, i);
    }
    
    placeholder.addEventListener("mouseover", function(e){
      var allTiles = e.currentTarget.querySelectorAll(".gridTile");
      for (var t=0, le = allTiles.length; t < le; t++)
        {
          TweenMax.to(allTiles[t], defaults.animTime, {css:{backgroundPosition:"0px 0px"}, ease:Power1.easeOut});
        }
    })
                               
    placeholder.addEventListener("mouseleave", function(e){
      var allTiles = e.currentTarget.querySelectorAll(".gridTile");
      for (var ti=0, len = allTiles.length; ti < len; ti++)
        {
          fixTilePosition(allTiles[ti], ti, defaults.animTime);
        }
    })
    
    function fixTilePosition(tile, ind, time)
    {
      if(time==null)time=0;
      var centr, centrCol, centrRow, offsetW, offsetH, left, top;
      
      centr = Math.floor(c * r / 2);
      centrCol = Math.ceil(centr/c);
      centrRow = Math.ceil(centr/r);
          
      offsetW = w/centrCol;
      offsetH = h/centrRow;
      
      left = (Math.round((ind % c - centrCol + 1) * offsetW));
      top = (Math.round((Math.floor(ind/c) - centrRow + 1) * offsetH));
      
      //console.log(left, top)
      
      TweenMax.to(tile, time, {css:{backgroundPosition:left+"px "+top+"px"}, ease:Power1.easeOut});
    }
  }
  
  ImageGrid(options);
}

function gsapAnimation() {
  select = (e) => document.querySelector(e);
  selectAll = (e) => document.querySelectorAll(e);

  var gridNum = 19,
    gridSize = [gridNum, gridNum], // number of cells in cols and rows
    gutter = 1, // in px
    container = select(".container");

  function createGrid() {
    var grid = document.createElement("div"),
      cols = gridSize[0],
      rows = gridSize[1],
      width = (100 - (cols - 1) * gutter) / cols,
      height = width,
      numCells = cols * rows,
      box;

    grid.style.cssText = `grid-template-columns: repeat(${cols}, 1fr); grid-template-rows: repeat(${rows}, 1fr); grid-gap: ${gutter}px;`;
    grid.setAttribute("class", "grid");

    for (i = 0; i < numCells; i++) {
      box = document.createElement("div");
      box.setAttribute("class", "cell");
      grid.appendChild(box);
    }
    container.appendChild(grid);
  }

  var tl = gsap.timeline({ repeat: -1, repeatDelay: 0, delay: 1 });

  function animateBoxes() {
    tl.to(".cell", {
      duration: 9,
      scale: "random(0.1, 2)",
      opacity: "random(0.3, 1)",
      x: "random(-300,300)",
      y: "random(-300,300)",
      z: "random(-400,400)",
      rotateX: "random(-360, 360, 180)",
      rotateY: "random(-360, 360, 180)",
      repeat: -1,
      repeatDelay: 2,
      repeatRefresh: true,
      ease: "power2.inOut",
      stagger: {
        amount: 1,
        grid: gridSize,
        ease: "sine.inOut",
        from: "center",
      },
    });
    gsap.to(".grid", {
      duration: 36,
      rotateX: 2160,
      rotateY: 720,
      ease: "none",
      repeat: -1,
    });
  }

  createGrid();
  animateBoxes();
}

function animaciones() {
  const abaut = document.querySelector(".galeria");
  const projects = document.querySelector(".projects");

  const hexagoUno = document.querySelector(".hexagonoUno");
  const hexagoDos = document.querySelector(".hexagonoDos");
  const hexagoTres = document.querySelector(".hexagonoTres");
  const hexagoCuatro = document.querySelector(".hexagonoCuatro");

  const me = document.querySelector(".me");
  const testimoniales = document.querySelector(".testimoniales");

  window.addEventListener("scroll", function () {
    if (abaut.getBoundingClientRect().top < 600) {
      hexagoUno.classList.add("animate__flipInY");
      hexagoDos.classList.add("animate__flipInY");
      hexagoTres.classList.add("animate__flipInY");
      hexagoCuatro.classList.add("animate__flipInY");
    }
    if (abaut.getBoundingClientRect().top < 300) {
      console.log("ya");
      me.classList.add("animate__fadeInTopLeft");
      testimoniales.classList.add("animate__fadeInTopRight");
    }
  });
}

function navegacionFija() {
  const barra = document.querySelector(".header");
  const sobreFestival = document.querySelector(".about");
  const body = document.querySelector("body");

  window.addEventListener("scroll", function () {
    if (sobreFestival.getBoundingClientRect().top < 0) {
      barra.classList.add("fijo");
      body.classList.add("body-scroll");
    } else {
      barra.classList.remove("fijo");
      body.classList.remove("body-scroll");
    }
  });
}

function scrollNav() {
  const enlaces = document.querySelectorAll(".navegacion-principal a");

  enlaces.forEach((enlace) => {
    enlace.addEventListener("click", function (e) {
      e.preventDefault();

      const seccionScroll = e.target.attributes.href.value;
      const seccion = document.querySelector(seccionScroll);
      seccion.scrollIntoView({ behavior: "smooth" });
    });
  });
}

function crearGaleria() {
  const galeria = document.querySelector(".galeria-imagenes");

  for (let i = 101; i <= 106; i++) {
    const imagen = document.createElement("picture");

    imagen.innerHTML = `<source srcset="build/img/${i}.webp" type="image/webp">
    <source srcset="build/img/${i}.png" type="image/png">
   <img loading="lazy" src="build/img/${i}.png" alt="imagen">`;
    imagen.onclick = function () {
      mostrarImagen(i);
    };

    galeria.appendChild(imagen);
  }
}
function mostrarImagen(i) {
  const imagen = document.createElement("picture");
  imagen.innerHTML = `<source srcset="build/img/${i}.webp" type="image/webp">
  <source srcset="build/img/${i}.png" type="image/png">
  <img loading="lazy" src="build/img/${i}.png" alt="imagen">`;

  //crea el overlay con la imagen
  const overlay = document.createElement("DIV");
  overlay.appendChild(imagen);
  overlay.classList.add("overlay");

  // texto desccriptivo
  const descripcion = document.createElement("DIV");
  const titulo = document.createElement("h1");
  switch (i) {
    case 101:
      titulo.textContent = "Bienes raices";
      break;
    case 102:
      titulo.textContent = "DevWebCamp";
      break;
    case 103:
      titulo.textContent = "AppSalon";
      break;
    case 104:
      titulo.textContent = "UpTask";
      break;
    case 105:
      titulo.textContent = "Mujeres y territorio";
      break;
    case 106:
      titulo.textContent = "Creemos";
      break;
    default:
      console.log("La opción elegida no es válida");
      break;
  }
  descripcion.classList.add("descripcion");
  titulo.classList.add("titulo");
  descripcion.appendChild(titulo);

  const texto = document.createElement("P");
  switch (i) {
    case 101:
      texto.innerHTML  =
        "This real estate project aims to expose different properties and is focused on performance. It has authentication for both user and administrator login, which allows the management of properties and sellers of the same. It also has validation in the forms, a me section, an announcements section and a contact section. Furthermore, it has been developed using the MVC and OOP architecture and is fully responsive. <a href='https://tijgadi.domcloud.io/' target='_blank'>Enlace</a> ";
      break;
    case 102:
      texto.innerHTML =
        "This project is designed for a technology conference and has a very complete administration panel, as well as a database. It has user and administrator authentication, which allows the creation of accounts through email validation. In addition, it has a PayPal payment gateway and sections for events, packages, workshops/conferences and ticket purchases. It has been developed using the MVC and OOP architecture, which allows it to be fully responsive and secure on all its URLs. Its design is elegant and attractive. <a href='https://qitdome.domcloud.io/' target='_blank'>Link</a>";
      break;
    case 103:
      texto.innerHTML =
        "This project is designed for a hairdresser and has an appointment scheduling system that validates dates, which allows appointments to be created in an orderly manner. In addition, you can create an account by mail validation and select the available services to create an appointment with all the necessary parameters. It offers an excellent user experience and has an administration panel that allows CRUD operations to be carried out on all page services. It has been developed using the MVC and OOP architecture, which allows it to be fully responsive.<a href='https://tijgadi.domcloud.io/' target='_blank'>Link</a ";

      break;
    case 104:
      texto.innerHTML =
        "This is an application for project management. With this tool you can create projects and assign tasks to each of them. Additionally, tasks can be filtered based on their status (pending or completed). The application allows to modify all the parameters of the project and the user profile, and has a validation to guarantee the security of all the projects and profiles. Likewise, it is possible to create new accounts through validation by mail. The application has been developed using the MVC and OOP architecture, which guarantees its efficiency and performance. The user experience is excellent and the application has a high level of performance.<a href='https://setguce.domcloud.io/' target='_blank'>Link</a";

      break;
    case 105:
      texto.textContent =
        "This web page has been designed with the purpose of exposing and highlighting the issue of women in the Sabana de Bogotá. With an enriching and vibrant approach, this platform offers an interactive experience to explore the dynamics of women in this region. The The website design stands out for its colorful and intuitive approach, allowing visitors to immerse themselves in a visually appealing and easy-to-navigate experience.This platform seeks to celebrate the diversity and empowerment of women in the Sabana de Bogotá.Discover and learn about these inspiring stories in a digital environment that reflects the vitality and importance of these women!";

      break;
    case 106:
      texto.textContent =
        "This web page has been created especially for students of the Universidad de los Andes who are studying a master's degree and wish to present their graduation project in a dynamic way. Its development has been carried out on the Wix platform, and it has a highly organic design inspired by the landscape of the Risaralda páramo. Through this platform, students will be able to share and exhibit their project in an interactive way, providing a unique experience for both them and visitors. Explore and immerse yourself in this virtual space that combines the academy with the natural beauty of the environment!";

      break;
    default:
      texto.textContent = "Código no válido";

      break;
  }

  texto.classList.add("texto-descriptivo");
  descripcion.appendChild(texto);
  const enlace = document.createElement("a");

  enlace.classList.add("enlace");
  overlay.appendChild(descripcion);
  overlay.appendChild(enlace);
  const botones = document.createElement("DIV");
  botones.classList.add("botones");

  //boton para pasar la imagen
  const izquierda = document.createElement("P");
  izquierda.textContent = "";
  izquierda.classList.add("btn-izquierda");
  let j = 1;
  let k = 11;
  let l = 21;
  let m = 31;
  let n = 41;
  let o = 51;
  izquierda.onclick = function () {
    switch (i) {
      case 101:
        if (10 >= j && j > 1) {
          j--;
          imagen.innerHTML = `<source srcset="build/img/${j}.webp" type="image/webp">
                              <source srcset="build/img/${j}.png" type="image/png">
                              <img loading="lazy" src="build/img/${j}.png" alt="imagen">`;
        }
        break;
      case 102:
        if (20 >= k && k > 11) {
          k--;
          imagen.innerHTML = `<source srcset="build/img/${k}.webp" type="image/webp">
          <source srcset="build/img/${k}.png" type="image/png">
          <img loading="lazy" src="build/img/${k}.png" alt="imagen">`;
        }
        break;
      case 103:
        if (30 >= l && l > 21) {
          l--;
          imagen.innerHTML = `<source srcset="build/img/${l}.webp" type="image/webp">
                              <source srcset="build/img/${l}.png" type="image/png">
                              <img loading="lazy" src="build/img/${l}.png" alt="imagen">`;
        }
        break;
      case 104:
        if (40 >= m && m > 31) {
          m--;
          imagen.innerHTML = `<source srcset="build/img/${m}.webp" type="image/webp">
                              <source srcset="build/img/${m}.png" type="image/png">
                              <img loading="lazy" src="build/img/${m}.png" alt="imagen">`;
        }
        break;
      case 105:
        if (50 >= n && n > 41) {
          n--;
          imagen.innerHTML = `<source srcset="build/img/${n}.webp" type="image/webp">
                                <source srcset="build/img/${n}.png" type="image/png">
                                <img loading="lazy" src="build/img/${n}.png" alt="imagen">`;
        }
        break;
      case 106:
        if (60 >= o && o > 51) {
          o--;
          imagen.innerHTML = `<source srcset="build/img/${o}.webp" type="image/webp">
                                  <source srcset="build/img/${o}.png" type="image/png">
                                  <img loading="lazy" src="build/img/${o}.png" alt="imagen">`;
        }
        break;
      default:
        console.log("La opción elegida no es válida");
        break;
    }
  };
  botones.appendChild(izquierda);
  overlay.appendChild(botones);

  //boton para cerrar el modal
  const cerrarModal = document.createElement("P");
  cerrarModal.textContent = "X";
  cerrarModal.classList.add("btn-cerrar");
  cerrarModal.onclick = function () {
    botones.remove();
    overlay.remove();
    const body = document.querySelector("body");
    body.classList.remove("fijar-body");
  };

  botones.appendChild(cerrarModal);

  //boton para pasar la imagen
  const derecha = document.createElement("P");
  derecha.textContent = "";
  derecha.classList.add("btn-derecha");
  derecha.onclick = function () {
    switch (i) {
      case 101:
        if (10 > j && j >= 0) {
          j++;
          imagen.innerHTML = `<source srcset="build/img/${j}.webp" type="image/webp">
                              <source srcset="build/img/${j}.png" type="image/png">
                              <img loading="lazy" src="build/img/${j}.png" alt="imagen">`;
        }
        break;
      case 102:
        if (20 > k && k > 10) {
          k++;
          imagen.innerHTML = `<source srcset="build/img/${k}.webp" type="image/webp">
                              <source srcset="build/img/${k}.png" type="image/png">
                              <img loading="lazy" src="build/img/${k}.png" alt="imagen">`;
        }
        break;
      case 103:
        if (30 > l && l >= 20) {
          l++;
          imagen.innerHTML = `<source srcset="build/img/${l}.webp" type="image/webp">
          <source srcset="build/img/${l}.png" type="image/png">
          <img loading="lazy" src="build/img/${l}.png" alt="imagen">`;
        }
        break;
      case 104:
        if (40 > m && m >= 30) {
          m++;
          imagen.innerHTML = `<source srcset="build/img/${m}.webp" type="image/webp">
          <source srcset="build/img/${m}.png" type="image/png">
          <img loading="lazy" src="build/img/${m}.png" alt="imagen">`;
        }
        break;
      case 105:
        if (50 > n && n >= 40) {
          n++;
          imagen.innerHTML = `<source srcset="build/img/${n}.webp" type="image/webp">
            <source srcset="build/img/${n}.png" type="image/png">
            <img loading="lazy" src="build/img/${n}.png" alt="imagen">`;
        }
        break;
      case 106:
        if (60 > o && o >= 50) {
          o++;
          imagen.innerHTML = `<source srcset="build/img/${o}.webp" type="image/webp">
              <source srcset="build/img/${o}.png" type="image/png">
              <img loading="lazy" src="build/img/${o}.png" alt="imagen">`;
        }
        break;
      default:
        console.log("La opción elegida no es válida");
        break;
    }
  };
  botones.appendChild(derecha);

  //añadir a la HTML
  const body = document.querySelector("body");
  body.appendChild(overlay);
  body.classList.add("fijar-body");
///////////////////////////////////////////////////////////////////
// Define una función que se ejecutará cuando el elemento esté en el campo de visión

}
